import { Navigate, Route, Routes } from 'react-router';
import { AuthProvider, useAuth } from './auth/auth-context';
import { Layout } from './components/Layout';
import { ApiKeysPage } from './pages/ApiKeysPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { MbtilesPage } from './pages/MbtilesPage';
import { ReadTokensPage } from './pages/ReadTokensPage';
import { ExamplesIndexPage } from './pages/examples/ExamplesIndexPage';
import { OpenLayersExamplePage } from './pages/examples/OpenLayersExamplePage';
import { MapLibreExamplePage } from './pages/examples/MapLibreExamplePage';
import { BrowserRouter } from 'react-router';

function ProtectedShell() {
  const { user, initializing } = useAuth();
  if (initializing) return <div style={{ padding: '2rem' }}>인증 확인 중…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/mbtiles" element={<MbtilesPage />} />
        <Route path="/api-keys" element={<ApiKeysPage />} />
        <Route path="/read-tokens" element={<ReadTokensPage />} />
        <Route path="/examples" element={<ExamplesIndexPage />} />
        <Route path="/examples/openlayers" element={<OpenLayersExamplePage />} />
        <Route path="/examples/maplibre" element={<MapLibreExamplePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function Router() {
  return (
    <BrowserRouter basename="/admin">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedShell />} />
      </Routes>
    </BrowserRouter>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
